// JWT token utilities
export interface TokenPayload {
  userId: string;
  role: string;
  fname: string;
  lname: string;
  exp: number;
}

/**
 * Decodes a JWT token without verification
 * Note: This only decodes the payload, it does NOT verify the signature
 */
export function decodeToken(token: string): TokenPayload | null {
  try {
    const parts = token.split(".");
    if (parts.length !== 3) {
      return null;
    }

    const payload = parts[1];
    const decoded = atob(payload.replace(/-/g, "+").replace(/_/g, "/"));
    const parsed = JSON.parse(decoded);
    
    return {
      userId: parsed.userId,
      role: parsed.role,
      fname: parsed.fname,
      lname: parsed.lname,
      exp: parsed.exp,
    } as TokenPayload;
  } catch (error) {
    console.error("Error decoding token:", error);
    return null;
  }
}

/**
 * Checks if a token is expired
 */
export function isTokenExpired(token: string): boolean {
  const payload = decodeToken(token);
  if (!payload) {
    return true;
  }

  // exp is in seconds, Date.now() is in milliseconds
  const expirationTime = payload.exp * 1000;
  return Date.now() >= expirationTime;
}

/**
 * Gets the expiration date of a token
 */
export function getTokenExpiration(token: string): Date | null {
  const payload = decodeToken(token);
  if (!payload) {
    return null;
  }

  return new Date(payload.exp * 1000);
}

